<script>
import StoreSearchResults from '@phoenix/mixins/components/store/StoreSearchResults';
import { PhxTabs, PhxTabPanel } from '@phx-styleguides/als';
import { mapActions } from 'vuex';

export default {
  components: {
    PhxTabs,
    PhxTabPanel,
  },

  mixins: [StoreSearchResults],

  props: {
    locations: {
      type: Array,
      default: () => [],
    },
    allStoresUrl: {
      type: String,
      default: '',
    },
    fitBoundStores: {
      type: Array,
      default: () => [],
    },
  },

  created() {
    if (!this.searchPerformed) {
      this.setStores(this.locations);
      this.setFitBoundStores(this.fitBoundStores);
    }
  },

  methods: {
    ...mapActions('storeSearch', ['setStores', 'changeCurrentTab', 'setFitBoundStores']),
  },
};
</script>

<template>
  <div data-cy="store-search-result">
    <section class="store-search-mobile">
      <phx-tabs
        v-cloak
        id="stores-search-tabs"
        tabs-class="stores-locator-tabs"
        theme="light"
        layout="stretch"
        :value="currentTab"
        @change="changeCurrentTab"
      >
        <phx-tab-panel id="map" class="store-search-mobile__map tab-panel--full" :label="$t('StoreSelector.tab.map')">
          <store-search-results-tab-map
            :stores="stores"
            :center="center"
            :zoom="zoom"
            :is-mobile="true"
            :all-stores-url="allStoresUrl"
            :should-load-stores-on-bounds-changed="shouldLoadStoresOnBoundsChanged"
          />
        </phx-tab-panel>
        <phx-tab-panel id="list" class="store-search-mobile__list" :label="$t('StoreSelector.tab.list')">
          <store-search-results-tab-list :stores="stores" :result-text="resultText" />
        </phx-tab-panel>
      </phx-tabs>
    </section>

    <section class="store-search-desktop">
      <store-search-results-tab-map
        :stores="stores"
        :center="center"
        :zoom="zoom"
        :all-stores-url="allStoresUrl"
        :should-load-stores-on-bounds-changed="shouldLoadStoresOnBoundsChanged"
      />
    </section>
  </div>
</template>
